import { format } from "path";
import React from "react";

interface DateFormatterProps {
  date?: string | Date | null; // date optional
  fallback?: string; // default value
}

export const DateFormatter: React.FC<DateFormatterProps> = ({
  date = null,
  fallback = "DD/MM/YYYY",
}) => {
  if (!date) {
    return <>{fallback}</>;
  }

  const dateObj =
    typeof date === "string" && date.trim() !== ""
      ? new Date(date)
      : date instanceof Date
      ? date
      : null;

  if (!dateObj || isNaN(dateObj.getTime())) {
    return <>{fallback}</>;
  }

  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const year = dateObj.getFullYear();

  return <>{`${day}/${month}/${year}`}</>;
};

// export default DateFormatter;

export const FormatDateForReport = (
  dateString?: string,
  fallback = "DD MMM YYYY",
  format = "DD MMM YYYY",
) => {
  if (!dateString) return "";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return fallback;

  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  const monthNames = [
    "jan","feb","mar","apr","may","jun",
    "jul","aug","sep","oct","nov","dec"
  ];

  switch (format) {
    //  02 apr 2026
    case "DD MMM YYYY":
      const monthText = monthNames[date.getMonth()];
      return `${day}-${monthText}-${year}`;

    // 02 04 2026
    case "DD MM YYYY":
      const monthNum = String(date.getMonth() + 1).padStart(2, "0");
      return `${day}-${monthNum}-${year}`;

    default:
      return new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }).format(date);
  }
};